import jwtDecode from "jwt-decode";
import useGenerateToken from "./GenerateToken";

const useValidateToken = () => {
  const { RefreshAccessToken } = useGenerateToken();

  async function checkTokenExpiry() {
    const token = sessionStorage.getItem("Token");
    const refreshToken = sessionStorage.getItem("RefreshToken");

    try {
      if (token && tokenHasExpired(token)) {
        await RefreshAccessToken(refreshToken);
      }
    } catch (e) {
      console.error("Error during token validation or refresh:", e);
      throw e;
    }
  }

  return {
    checkTokenExpiry,
  };
};

export const tokenHasExpired = (jwt) => {
  // Count Down
  const timestamp = parseInt(jwtDecode(jwt)["exp"]) * 1000;
  const expiryDate = new Date(timestamp);

  // Current date
  const now = new Date().getTime();

  // If JWT expired
  if (expiryDate < now) {
    return true;
  }

  return false;
};

export default useValidateToken;
